// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Component } from '@angular/core';
import { OrganizationsFacadeService } from '@app/access-management/state/organizations.facade';
import { Loadable, Loaded, LoadingStatus, ScopeCategory } from '@app/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-organizations-list',
  templateUrl: './organizations-list.component.html',
  styleUrls: ['./organizations-list.component.scss']
})
export class OrganizationsListComponent {
  readonly loadableOrganizations$: Observable<Loaded<ScopeCategory[]> | Loadable>;
  LOAD_COMPLETE = LoadingStatus.LOAD_COMPLETE;

  readonly columns = [
    {
      name: 'ID',
      prop: 'id',
      cellClass: 'text-info'
    },
    {
      name: 'Organization Name',
      prop: 'name'
    },
    {
      name: 'Website',
      prop: 'website'
    },
    {
      name: 'Is Parent',
      prop: 'IsParent'
    }
  ];

  constructor(private organizationsFacade: OrganizationsFacadeService) {
    this.organizationsFacade.initialize();

    this.loadableOrganizations$ = this.organizationsFacade.loadableOrganizations$;
  }

  onSelectRow({ selected }: SelectedRowstable) {
    const selectedRow = selected[0];
    this.organizationsFacade.selectOrganization(selectedRow);
  }
}

interface SelectedRowstable {
  selected: any[];
}



// WEBPACK FOOTER //
// ./src/app/access-management/organizations/organizations-list/organizations-list.component.ts